import { render, staticRenderFns } from "./ParcelshopMap.vue?vue&type=template&id=0f14c20d"
import script from "./ParcelshopMap.vue?vue&type=script&lang=js"
export * from "./ParcelshopMap.vue?vue&type=script&lang=js"
import style0 from "./ParcelshopMap.vue?vue&type=style&index=0&id=0f14c20d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports